export const TARGET_ROUTES_QUERY_KEY = ["targets", "routes"] as const
